module.exports = __webpack_public_path__ + "img/icon_stat_second.b3b9395d.svg";